import { Link } from 'react-router-dom';

export function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto px-4 py-3 h-16 flex items-center">
          <Link to="/" className="text-lg font-semibold">
            Brand Check
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div>
            <main className="container mx-auto px-4 py-8">
              <div className="max-w-4xl mx-auto prose prose-gray dark:prose-invert">
                <h1 className="text-3xl font-bold text-gray-900 mb-8">
                  PRIVACY POLICY
                </h1>

                <p className="text-sm text-gray-600 mb-6">
                  Last updated <strong>September 09, 2025</strong>
                </p>

                <div>
                  <span>
                    <span>
                      This Privacy Notice for{' '}
                      <strong>Hacket Services OÜ</strong> ("we," "us," or
                      "our"), describes how and why we might access, collect,
                      store, use, and/or share ("process") your personal
                      information when you use our Services ("Services"),
                      including when you:
                    </span>
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Visit our website at{' '}
                      <span>
                        <a target="_blank" href="https://usebrandcheck.com">
                          https://usebrandcheck.com
                        </a>
                      </span>{' '}
                      or any website of ours that links to this Privacy Notice
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Use <strong>Brand Check</strong>. Our SaaS tool analyzes
                      public influencer social media profiles from platforms
                      such as Instagram and TikTok and uses AI to analyze each
                      post to determine if it is a paid collaboration with a
                      competing brand. This helps social media marketing
                      agencies vet influencers for new campaigns.
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Engage with us in other related ways, including any sales,
                      marketing, or events
                    </span>
                  </li>
                </ul>

                <div>
                  <span>
                    <strong>Questions or concerns?&nbsp;</strong>Reading this
                    Privacy Notice will help you understand your privacy rights
                    and choices. We are responsible for making decisions about
                    how your personal information is processed. If you do not
                    agree with our policies and practices, please do not use our
                    Services. If you still have any questions or concerns,
                    please contact us at{' '}
                    <span>
                      <a target="_blank" href="mailto:info@usehacket.com">
                        info@usehacket.com
                      </a>
                    </span>
                    .
                  </span>
                </div>

                <div>
                  <br />
                </div>
                <div>
                  <br />
                </div>

                <div>
                  <strong>
                    <span>
                      <h2>SUMMARY OF KEY POINTS</h2>
                    </span>
                  </strong>
                </div>

                <div>
                  <span>
                    <strong>
                      <em>
                        This summary provides key points from our Privacy
                        Notice, but you can find out more details about any of
                        these topics by clicking the link following each key
                        point or by using our&nbsp;
                      </em>
                    </strong>
                  </span>
                  <a data-custom-class="link" href="#toc">
                    <span>
                      <strong>
                        <em>table of contents</em>
                      </strong>
                    </span>
                  </a>
                  <span>
                    <strong>
                      <em>
                        &nbsp;below to find the section you are looking for.
                      </em>
                    </strong>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>What personal information do we process?</strong>{' '}
                    When you visit, use, or navigate our Services, we may
                    process personal information depending on how you interact
                    with us and the Services, the choices you make, and the
                    products and features you use. Learn more about&nbsp;
                  </span>
                  <a data-custom-class="link" href="#personalinfo">
                    <span>personal information you disclose to us</span>
                  </a>
                  <span>.</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>
                      Do we process any sensitive personal information?&nbsp;
                    </strong>
                    Some of the information may be considered "special" or
                    "sensitive" in certain jurisdictions, for example your
                    racial or ethnic origins, sexual orientation, and religious
                    beliefs. We do not process sensitive personal information.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>
                      Do we collect any information from third parties?
                    </strong>{' '}
                    We do not collect any information from third parties.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>How do we process your information?</strong> We
                    process your information to provide, improve, and administer
                    our Services, communicate with you, for security and fraud
                    prevention, and to comply with law. We may also process your
                    information for other purposes with your consent. We process
                    your information only when we have a valid legal reason to
                    do so. Learn more about&nbsp;
                  </span>
                  <a data-custom-class="link" href="#infouse">
                    <span>how we process your information</span>
                  </a>
                  <span>.</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>
                      In what situations and with which parties do we share
                      personal information?
                    </strong>{' '}
                    We may share information in specific situations and with
                    specific third parties. Learn more about&nbsp;
                  </span>
                  <a data-custom-class="link" href="#whoshare">
                    <span>
                      when and with whom we share your personal information
                    </span>
                  </a>
                  <span>.</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>How do we keep your information safe?</strong> We
                    have adequate organizational and technical processes and
                    procedures in place to protect your personal information.
                    However, no electronic transmission over the internet or
                    information storage technology can be guaranteed to be 100%
                    secure, so we cannot promise or guarantee that hackers,
                    cybercriminals, or other unauthorized third parties will not
                    be able to defeat our security and improperly collect,
                    access, steal, or modify your information. Learn more
                    about&nbsp;
                  </span>
                  <a data-custom-class="link" href="#infosafe">
                    <span>how we keep your information safe</span>
                  </a>
                  <span>.</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>What are your rights?</strong> Depending on where
                    you are located geographically, the applicable privacy law
                    may mean you have certain rights regarding your personal
                    information. Learn more about&nbsp;
                  </span>
                  <a data-custom-class="link" href="#privacyrights">
                    <span>your privacy rights</span>
                  </a>
                  <span>.</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>How do you exercise your rights?</strong> The
                    easiest way to exercise your rights is by visiting{' '}
                    <span>
                      <a target="_blank" href="https://usebrandcheck.com">
                        https://usebrandcheck.com
                      </a>
                    </span>
                    , or by contacting us. We will consider and act upon any
                    request in accordance with applicable data protection laws.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    Want to learn more about what we do with any information we
                    collect?&nbsp;
                  </span>
                  <a data-custom-class="link" href="#toc">
                    <span>Review the Privacy Notice in full</span>
                  </a>
                  <span>.</span>
                </div>

                <div>
                  <br />
                </div>
                <div>
                  <br />
                </div>

                <div id="toc">
                  <span>
                    <span>
                      <span>
                        <strong>
                          <h2>TABLE OF CONTENTS</h2>
                        </strong>
                        &nbsp;
                      </span>
                      &nbsp;
                    </span>
                    &nbsp;
                  </span>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#infocollect">
                      <span>1. WHAT INFORMATION DO WE COLLECT?</span>
                    </a>
                  </span>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#infouse">
                      <span>2. HOW DO WE PROCESS YOUR INFORMATION?</span>
                    </a>
                  </span>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#legalbases">
                      <span>
                        3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR
                        PERSONAL INFORMATION?
                      </span>
                    </a>
                  </span>
                </div>

                <div>
                  <span>
                    <span>
                      <a data-custom-class="link" href="#whoshare">
                        4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL
                        INFORMATION?
                      </a>
                    </span>
                  </span>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#cookies">
                      <span>
                        5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
                      </span>
                    </a>
                  </span>
                </div>

                <div>
                  <a data-custom-class="link" href="#ai">
                    <span>
                      6. DO WE OFFER ARTIFICIAL INTELLIGENCE-BASED PRODUCTS?
                    </span>
                  </a>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#sociallogins">
                      <span>
                        <span>
                          <span>7. HOW DO WE HANDLE YOUR SOCIAL LOGINS?</span>
                        </span>
                      </span>
                    </a>
                  </span>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#intltransfers">
                      <span>
                        8. IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?
                      </span>
                    </a>
                  </span>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#inforetain">
                      <span>9. HOW LONG DO WE KEEP YOUR INFORMATION?</span>
                    </a>
                  </span>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#infosafe">
                      <span>10. HOW DO WE KEEP YOUR INFORMATION SAFE?</span>
                    </a>
                  </span>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#infominors">
                      <span>11. DO WE COLLECT INFORMATION FROM MINORS?</span>
                    </a>
                  </span>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#privacyrights">
                      <span>12. WHAT ARE YOUR PRIVACY RIGHTS?</span>
                    </a>
                  </span>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#DNT">
                      <span>13. CONTROLS FOR DO-NOT-TRACK FEATURES</span>
                    </a>
                  </span>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#uslaws">
                      <span>
                        14. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY
                        RIGHTS?
                      </span>
                    </a>
                  </span>
                </div>

                <div>
                  <span>
                    <a data-custom-class="link" href="#policyupdates">
                      <span>15. DO WE MAKE UPDATES TO THIS NOTICE?</span>
                    </a>
                  </span>
                </div>

                <div>
                  <a data-custom-class="link" href="#contact">
                    <span>16. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
                  </a>
                </div>

                <div>
                  <a data-custom-class="link" href="#request">
                    <span>
                      17. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE
                      COLLECT FROM YOU?
                    </span>
                  </a>
                </div>

                <div>
                  <br />
                </div>
                <div>
                  <br />
                </div>

                <div id="infocollect">
                  <span>
                    <span>
                      <span>
                        <strong>
                          <h2>1. WHAT INFORMATION DO WE COLLECT?</h2>
                        </strong>
                      </span>
                    </span>
                  </span>
                  <span id="personalinfo">
                    <span>
                      <strong>
                        <h3>Personal information you disclose to us</h3>
                      </strong>
                    </span>
                  </span>
                  <span>
                    <span>
                      <strong>
                        <em>In Short:</em>
                      </strong>
                      <em>
                        &nbsp;We collect personal information that you provide
                        to us.
                      </em>
                    </span>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We collect personal information that you voluntarily provide
                    to us when you register on the Services, express an interest
                    in obtaining information about us or our products and
                    Services, when you participate in activities on the
                    Services, or otherwise when you contact us.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>Personal Information Provided by You.</strong> The
                    personal information that we collect depends on the context
                    of your interactions with us and the Services, the choices
                    you make, and the products and features you use. The
                    personal information we collect may include the following:
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>email addresses</span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>passwords</span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>names</span>
                  </li>
                </ul>

                <div id="sensitiveinfo">
                  <span>
                    <strong>Sensitive Information.</strong> We do not process
                    sensitive information.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>Payment Data.</strong> We may collect data necessary
                    to process your payment if you choose to make purchases,
                    such as your payment instrument number, and the security
                    code associated with your payment instrument. All payment
                    data is handled and stored by <strong>Paddle</strong>. You
                    may find their privacy notice link(s) here:
                    <span>
                      <a
                        target="_blank"
                        href="https://paddle.com/legal/privacy"
                      >
                        https://paddle.com/legal/privacy
                      </a>
                    </span>
                    .
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>Social Media Login Data.&nbsp;</strong>We may
                    provide you with the option to register with us using your
                    existing social media account details, like your Facebook,
                    X, or other social media account. If you choose to register
                    in this way, we will collect certain profile information
                    about you from the social media provider, as described in
                    the section called "
                  </span>
                  <a data-custom-class="link" href="#sociallogins">
                    <strong>HOW DO WE HANDLE YOUR SOCIAL LOGINS?</strong>
                  </a>
                  <span>" below.</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    All personal information that you provide to us must be
                    true, complete, and accurate, and you must notify us of any
                    changes to such personal information.
                  </span>
                  <span>
                    <strong>
                      <h3>Information automatically collected</h3>
                    </strong>
                  </span>
                  <span>
                    <span>
                      <strong>
                        <em>In Short:</em>
                      </strong>
                      <em>
                        &nbsp;Some information — such as your Internet Protocol
                        (IP) address and/or browser and device characteristics —
                        is collected automatically when you visit our Services.
                      </em>
                    </span>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We automatically collect certain information when you visit,
                    use, or navigate the Services. This information does not
                    reveal your specific identity (like your name or contact
                    information) but may include device and usage information,
                    such as your IP address, browser and device characteristics,
                    operating system, language preferences, referring URLs,
                    device name, country, location, information about how and
                    when you use our Services, and other technical information.
                    This information is primarily needed to maintain the
                    security and operation of our Services, and for our internal
                    analytics and reporting purposes.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    Like many businesses, we also collect information through
                    cookies and similar technologies.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>The information we collect includes:</span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <em>Log and Usage Data.</em> Log and usage data is
                      service-related, diagnostic, usage, and performance
                      information our servers automatically collect when you
                      access or use our Services and which we record in log
                      files. Depending on how you interact with us, this log
                      data may include your IP address, device information,
                      browser type, and settings and information about your
                      activity in the Services (such as the date/time stamps
                      associated with your usage, pages and files viewed,
                      searches, and other actions you take such as which
                      features you use), device event information (such as
                      system activity, error reports (sometimes called "crash
                      dumps"), and hardware settings).
                    </span>
                  </li>
                </ul>

                <div>
                  <strong>
                    <h3>Google API</h3>
                  </strong>
                  <span>
                    Our use of information received from Google APIs will adhere
                    to&nbsp;
                  </span>
                  <a
                    href="https://developers.google.com/terms/api-services-user-data-policy"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <span>Google API Services User Data Policy</span>
                  </a>
                  <span>, including the&nbsp;</span>
                  <a
                    href="https://developers.google.com/terms/api-services-user-data-policy#limited-use"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <span>Limited Use requirements</span>
                  </a>
                  <span>.</span>
                </div>

                <div>
                  <br />
                </div>

                <div id="infouse">
                  <span>
                    <span>
                      <strong>
                        <h2>2. HOW DO WE PROCESS YOUR INFORMATION?</h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    <strong>
                      <em>In Short:&nbsp;</em>
                    </strong>
                    <em>
                      We process your information to provide, improve, and
                      administer our Services, communicate with you, for
                      security and fraud prevention, and to comply with law. We
                      process the personal information for the following
                      purposes listed below. We may also process your
                      information for other purposes only with your prior
                      explicit consent.
                    </em>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>
                      We process your personal information for a variety of
                      reasons, depending on how you interact with our Services,
                      including:
                    </strong>
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>
                        To facilitate account creation and authentication and
                        otherwise manage user accounts.&nbsp;
                      </strong>
                      We may process your information so you can create and log
                      in to your account, as well as keep your account in
                      working order.
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>
                        To deliver and facilitate delivery of services to the
                        user.&nbsp;
                      </strong>
                      We may process your information to provide you with the
                      requested service.
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>
                        To respond to user inquiries/offer support to
                        users.&nbsp;
                      </strong>
                      We may process your information to respond to your
                      inquiries and solve any potential issues you might have
                      with the requested service.
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>
                        To <span>fulfill</span> and manage your orders.
                      </strong>{' '}
                      We may process your information to <span>fulfill</span>{' '}
                      and manage your orders, payments, returns, and exchanges
                      made through the Services.
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>
                        To save or protect an individual's vital interest.
                      </strong>{' '}
                      We may process your information when necessary to save or
                      protect an individual’s vital interest, such as to prevent
                      harm.
                    </span>
                  </li>
                </ul>

                <div>
                  <br />
                </div>

                <div id="legalbases">
                  <strong>
                    <span>
                      <h2>
                        3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR
                        INFORMATION?
                      </h2>
                    </span>
                  </strong>
                  <em>
                    <span>
                      <strong>In Short:&nbsp;</strong>We only process your
                      personal information when we believe it is necessary and
                      we have a valid legal reason (i.e., legal basis) to do so
                      under applicable law, like with your consent, to comply
                      with laws, to provide you with services to enter into or
                      fulfill our contractual obligations, to protect your
                      rights, or to fulfill our legitimate business interests.
                    </span>
                  </em>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <em>
                    <strong>
                      <u>
                        If you are located in the EU or UK, this section applies
                        to you.
                      </u>
                    </strong>
                  </em>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    The General Data Protection Regulation (GDPR) and UK GDPR
                    require us to explain the valid legal bases we rely on in
                    order to process your personal information. As such, we may
                    rely on the following legal bases to process your personal
                    information:
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Consent.&nbsp;</strong>We may process your
                      information if you have given us permission (i.e.,
                      consent) to use your personal information for a specific
                      purpose. You can withdraw your consent at any time. Learn
                      more about&nbsp;
                    </span>
                    <a data-custom-class="link" href="#withdrawconsent">
                      <span>withdrawing your consent</span>
                    </a>
                    <span>.</span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Performance of a Contract.</strong> We may process
                      your personal information when we believe it is necessary
                      to fulfill our contractual obligations to you, including
                      providing our Services or at your request prior to
                      entering into a contract with you.
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Legal Obligations.</strong> We may process your
                      information where we believe it is necessary for
                      compliance with our legal obligations, such as to
                      cooperate with a law enforcement body or regulatory
                      agency, exercise or defend our legal rights, or disclose
                      your information as evidence in litigation in which we are
                      involved.
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Vital Interests.</strong> We may process your
                      information where we believe it is necessary to protect
                      your vital interests or the vital interests of a third
                      party, such as situations involving potential threats to
                      the safety of any person.
                    </span>
                  </li>
                </ul>

                <div>
                  <br />
                </div>

                <div>
                  <strong>
                    <u>
                      <em>
                        If you are located in Canada, this section applies to
                        you.
                      </em>
                    </u>
                  </strong>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We may process your information if you have given us
                    specific permission (i.e., express consent) to use your
                    personal information for a specific purpose, or in
                    situations where your permission can be inferred (i.e.,
                    implied consent). You can&nbsp;
                  </span>
                  <a data-custom-class="link" href="#withdrawconsent">
                    <span>withdraw your consent</span>
                  </a>
                  <span>&nbsp;at any time.</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    In some exceptional cases, we may be legally permitted under
                    applicable law to process your information without your
                    consent, including, for example:
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      If collection is clearly in the interests of an individual
                      and consent cannot be obtained in a timely way
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      For investigations and fraud detection and prevention
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      For business transactions provided certain conditions are
                      met
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      If it is contained in a witness statement and the
                      collection is necessary to assess, process, or settle an
                      insurance claim
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      For identifying injured, ill, or deceased persons and
                      communicating with next of kin
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      If we have reasonable grounds to believe an individual has
                      been, is, or may be victim of financial abuse
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      If it is reasonable to expect collection and use with
                      consent would compromise the availability or the accuracy
                      of the information and the collection is reasonable for
                      purposes related to investigating a breach of an agreement
                      or a contravention of the laws of Canada or a province
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      If disclosure is required to comply with a subpoena,
                      warrant, court order, or rules of the court relating to
                      the production of records
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      If it was produced by an individual in the course of their
                      employment, business, or profession and the collection is
                      consistent with the purposes for which the information was
                      produced
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      If the collection is solely for journalistic, artistic, or
                      literary purposes
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      If the information is publicly available and is specified
                      by the regulations
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      We may disclose de-identified information for approved
                      research or statistics projects, subject to ethics
                      oversight and confidentiality commitments
                    </span>
                  </li>
                </ul>

                <div>
                  <br />
                </div>

                <div id="whoshare">
                  <span>
                    <span>
                      <strong>
                        <h2>
                          4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL
                          INFORMATION?
                        </h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    <strong>
                      <em>In Short:&nbsp;</em>
                    </strong>
                    <em>
                      We may share information in specific situations described
                      in this section and/or with the following third parties.
                    </em>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>
                      Vendors, Consultants, and Other Third-Party Service
                      Providers.
                    </strong>{' '}
                    We may share your data with third-party vendors, service
                    providers, contractors, or agents ("third parties") who
                    perform services for us or on our behalf and require access
                    to such information to do that work. We have contracts in
                    place with our third parties, which are designed to help
                    safeguard your personal information. This means that they
                    cannot do anything with your personal information unless we
                    have instructed them to do it. They will also not share your
                    personal information with any organization apart from us.
                    They also commit to protect the data they hold on our behalf
                    and to retain it for the period we instruct.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    The third parties we may share personal information with are
                    as follows:
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Invoice and Billing</strong>
                    </span>
                  </li>
                </ul>

                <div>
                  <span>paddle</span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>
                        User Account Registration and Authentication
                      </strong>
                    </span>
                  </li>
                </ul>

                <div>
                  <span>Google OAuth 2.0</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We also may need to share your personal information in the
                    following situations:
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Business Transfers.</strong> We may share or
                      transfer your information in connection with, or during
                      negotiations of, any merger, sale of company assets,
                      financing, or acquisition of all or a portion of our
                      business to another company.
                    </span>
                  </li>
                </ul>

                <div>
                  <br />
                </div>

                <div id="cookies">
                  <span>
                    <span>
                      <strong>
                        <h2>
                          5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
                        </h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    <strong>
                      <em>In Short:</em>
                    </strong>
                    <em>
                      &nbsp;We may use cookies and other tracking technologies
                      to collect and store your information.
                    </em>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We may use cookies and similar tracking technologies (like
                    web beacons and pixels) to gather information when you
                    interact with our Services. Some online tracking
                    technologies help us maintain the security of our Services
                    and your account, prevent crashes, fix bugs, save your
                    preferences, and assist with basic site functions.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We also permit third parties and service providers to use
                    online tracking technologies on our Services for analytics
                    and advertising, including to help manage and display
                    advertisements, to tailor advertisements to your interests,
                    or to send abandoned shopping cart reminders (depending on
                    your communication preferences). The third parties and
                    service providers use their technology to provide
                    advertising about products and services tailored to your
                    interests which may appear either on our Services or on
                    other websites.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <span>
                      To the extent these online tracking technologies are
                      deemed to be a "sale"/"sharing" (which includes targeted
                      advertising, as defined under the applicable laws) under
                      applicable US state laws, you can opt out of these online
                      tracking technologies by submitting a request as described
                      below under section&nbsp;
                    </span>
                    <a data-custom-class="link" href="#uslaws">
                      DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
                    </a>
                    <span>.</span>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    Specific information about how we use such technologies and
                    how you can refuse certain cookies is set out in our Cookie
                    Notice.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div id="ai">
                  <strong>
                    <span>
                      <h2>
                        6. DO WE OFFER ARTIFICIAL INTELLIGENCE-BASED PRODUCTS?
                      </h2>
                    </span>
                  </strong>
                  <em>
                    <span>
                      <strong>In Short:</strong>
                      <em>
                        &nbsp;We offer products, features, or tools powered by
                        artificial intelligence, machine learning, or similar
                        technologies.
                      </em>
                    </span>
                  </em>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <span>
                      As part of our Services, we offer products, features, or
                      tools powered by artificial intelligence, machine
                      learning, or similar technologies (collectively, "AI
                      Products"). These tools are designed to enhance your
                      experience and provide you with innovative solutions. The
                      terms in this Privacy Notice govern your use of the AI
                      Products within our Services.
                    </span>
                  </span>
                </div>

                <div>
                  <span>
                    <br />
                  </span>
                </div>

                <div>
                  <strong>
                    <span>
                      <span>Our AI Products</span>
                    </span>
                  </strong>
                </div>

                <div>
                  <span>
                    <br />
                  </span>
                </div>

                <div>
                  <span>
                    <span>
                      Our AI Products are designed for the following functions:
                    </span>
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <span>Image analysis</span>
                    </span>
                  </li>
                </ul>

                <div>
                  <span></span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <span>Video analysis</span>
                    </span>
                  </li>
                </ul>

                <div>
                  <span>
                    <br />
                  </span>
                </div>

                <div>
                  <strong>
                    <span>
                      <span>How We Process Your Data Using AI</span>
                    </span>
                  </strong>
                </div>

                <div>
                  <span>
                    <br />
                  </span>
                </div>

                <div>
                  <span>
                    <span>
                      All personal information processed using our AI Products
                      is handled in line with our Privacy Notice and our
                      agreement with third parties. This ensures high security
                      and safeguards your personal information throughout the
                      process, giving you peace of mind about your data's
                      safety.
                    </span>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div id="sociallogins">
                  <span>
                    <span>
                      <strong>
                        <h2>7. HOW DO WE HANDLE YOUR SOCIAL LOGINS?</h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    <strong>
                      <em>In Short:&nbsp;</em>
                    </strong>
                    <em>
                      If you choose to register or log in to our Services using
                      a social media account, we may have access to certain
                      information about you.
                    </em>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    Our Services offer you the ability to register and log in
                    using your third-party social media account details (like
                    your Facebook or X logins). Where you choose to do this, we
                    will receive certain profile information about you from your
                    social media provider. The profile information we receive
                    may vary depending on the social media provider concerned,
                    but will often include your name, email address, friends
                    list, and profile picture, as well as other information you
                    choose to make public on such a social media platform.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We will use the information we receive only for the purposes
                    that are described in this Privacy Notice or that are
                    otherwise made clear to you on the relevant Services. Please
                    note that we do not control, and are not responsible for,
                    other uses of your personal information by your third-party
                    social media provider. We recommend that you review their
                    privacy notice to understand how they collect, use, and
                    share your personal information, and how you can set your
                    privacy preferences on their sites and apps.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div id="intltransfers">
                  <span>
                    <span>
                      <strong>
                        <h2>
                          8. IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?
                        </h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    <strong>
                      <em>In Short:&nbsp;</em>
                    </strong>
                    <em>
                      We may transfer, store, and process your information in
                      countries other than your own.
                    </em>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div data-custom-class="body_text">
                  <span>
                    Our servers are located in the{' '}
                    <strong>United States</strong>. Regardless of your location,
                    please be aware that your information may be transferred to,
                    stored by, and processed by us in our facilities and in the
                    facilities of the third parties with whom we may share your
                    personal information (see "
                  </span>
                  <a data-custom-class="link" href="#whoshare">
                    <strong>
                      WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
                    </strong>
                  </a>
                  <span>
                    " above), including facilities in the{' '}
                    <strong>United Kingdom,</strong> and other countries.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    If you are a resident in the European Economic Area (EEA),
                    United Kingdom (UK), or Switzerland, then these countries
                    may not necessarily have data protection laws or other
                    similar laws as comprehensive as those in your country.
                    However, we will take all necessary measures to protect your
                    personal information in accordance with this Privacy Notice
                    and applicable law.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    European Commission's Standard Contractual Clauses:
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We have implemented measures to protect your personal
                    information, including by using the European Commission's
                    Standard Contractual Clauses for transfers of personal
                    information between our group companies and between us and
                    our third-party providers. These clauses require all
                    recipients to protect all personal information that they
                    process originating from the EEA or UK in accordance with
                    European data protection laws and regulations. Our Standard
                    Contractual Clauses can be provided upon request. We have
                    implemented similar appropriate safeguards with our
                    third-party service providers and partners and further
                    details can be provided upon request.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div id="inforetain">
                  <span>
                    <span>
                      <strong>
                        <h2>9. HOW LONG DO WE KEEP YOUR INFORMATION?</h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    <strong>
                      <em>In Short:&nbsp;</em>
                    </strong>
                    <em>
                      We keep your information for as long as necessary to
                      fulfill the purposes outlined in this Privacy Notice
                      unless otherwise required by law.
                    </em>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We will only keep your personal information for as long as
                    it is necessary for the purposes set out in this Privacy
                    Notice, unless a longer retention period is required or
                    permitted by law (such as tax, accounting, or other legal
                    requirements). No purpose in this notice will require us
                    keeping your personal information for longer than the period
                    of time in which users have an account with us.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    When we have no ongoing legitimate business need to process
                    your personal information, we will either delete or
                    anonymize such information, or, if this is not possible (for
                    example, because your personal information has been stored
                    in backup archives), then we will securely store your
                    personal information and isolate it from any further
                    processing until deletion is possible.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div id="infosafe">
                  <span>
                    <span>
                      <strong>
                        <h2>10. HOW DO WE KEEP YOUR INFORMATION SAFE?</h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    <strong>
                      <em>In Short:&nbsp;</em>
                    </strong>
                    <em>
                      We aim to protect your personal information through a
                      system of organizational and technical security measures.
                    </em>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We have implemented appropriate and reasonable technical and
                    organizational security measures designed to protect the
                    security of any personal information we process. However,
                    despite our safeguards and efforts to secure your
                    information, no electronic transmission over the Internet or
                    information storage technology can be guaranteed to be 100%
                    secure, so we cannot promise or guarantee that hackers,
                    cybercriminals, or other unauthorized third parties will not
                    be able to defeat our security and improperly collect,
                    access, steal, or modify your information. Although we will
                    do our best to protect your personal information,
                    transmission of personal information to and from our
                    Services is at your own risk. You should only access the
                    Services within a secure environment.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div id="infominors">
                  <span>
                    <span>
                      <strong>
                        <h2>11. DO WE COLLECT INFORMATION FROM MINORS?</h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    <strong>
                      <em>In Short:&nbsp;</em>
                    </strong>
                    <em>
                      We do not knowingly collect data from or market to
                      children under 18 years of age or the equivalent age as
                      specified by law in your jurisdiction.
                    </em>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We do not knowingly collect, solicit data from, or market to
                    children under 18 years of age or the equivalent age as
                    specified by law in your jurisdiction, nor do we knowingly
                    sell such personal information. By using the Services, you
                    represent that you are at least 18 or the equivalent age as
                    specified by law in your jurisdiction or that you are the
                    parent or guardian of such a minor and consent to such minor
                    dependent’s use of the Services. If we learn that personal
                    information from users less than 18 years of age or the
                    equivalent age as specified by law in your jurisdiction has
                    been collected, we will deactivate the account and take
                    reasonable measures to promptly delete such data from our
                    records. If you become aware of any data we may have
                    collected from children under age 18 or the equivalent age
                    as specified by law in your jurisdiction, please contact us
                    at{' '}
                    <span>
                      <a target="_blank" href="mailto:info@usehacket.com">
                        info@usehacket.com
                      </a>
                    </span>
                    .
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div id="privacyrights">
                  <span>
                    <span>
                      <strong>
                        <h2>12. WHAT ARE YOUR PRIVACY RIGHTS?</h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    In some regions (like the EEA, UK, Switzerland, and Canada),
                    you have certain rights under applicable data protection
                    laws. These may include the right (i) to request access and
                    obtain a copy of your personal information, (ii) to request
                    rectification or erasure; (iii) to restrict the processing
                    of your personal information; (iv) if applicable, to data
                    portability; and (v) not to be subject to automated
                    decision-making. If a decision that produces legal or
                    similarly significant effects is made solely by automated
                    means, we will inform you, explain the main factors, and
                    offer a simple way to request human review. In certain
                    circumstances, you may also have the right to object to the
                    processing of your personal information. You can make such a
                    request by contacting us by using the contact details
                    provided in the section "
                  </span>
                  <a data-custom-class="link" href="#contact">
                    <span>
                      <span>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
                    </span>
                  </a>
                  <span>" below.</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We will consider and act upon any request in accordance with
                    applicable data protection laws.
                  </span>
                </div>

                <div>
                  <span>&nbsp;</span>
                </div>

                <div>
                  <span>
                    If you are located in the EEA or UK and you believe we are
                    unlawfully processing your personal information, you also
                    have the right to complain to your Member State data
                    protection authority or&nbsp;
                  </span>
                  <a
                    href="https://ico.org.uk/make-a-complaint/data-protection-complaints/data-protection-complaints/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <span>
                      <span>UK data protection authority</span>
                    </span>
                  </a>
                  <span>.</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    If you are located in Switzerland, you may contact the&nbsp;
                  </span>
                  <a
                    href="https://www.edoeb.admin.ch/edoeb/en/home.html"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <span>
                      <span>
                        <span>
                          Federal Data Protection and Information Commissioner
                        </span>
                      </span>
                    </span>
                  </a>
                  <span>.</span>
                </div>

                <div>
                  <br />
                </div>

                <div id="withdrawconsent">
                  <span>
                    <strong>
                      <u>Withdrawing your consent:</u>
                    </strong>{' '}
                    If we are relying on your consent to process your personal
                    information, which may be express and/or implied consent
                    depending on the applicable law, you have the right to
                    withdraw your consent at any time. You can withdraw your
                    consent at any time by contacting us by using the contact
                    details provided in the section "
                  </span>
                  <a data-custom-class="link" href="#contact">
                    <span>
                      <span>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
                    </span>
                  </a>
                  <span>" below or updating your preferences.</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    However, please note that this will not affect the
                    lawfulness of the processing before its withdrawal nor, when
                    applicable law allows, will it affect the processing of your
                    personal information conducted in reliance on lawful
                    processing grounds other than consent.
                  </span>
                  <span>
                    <strong>
                      <h3>Account Information</h3>
                    </strong>
                  </span>
                  <span>
                    If you would at any time like to review or change the
                    information in your account or terminate your account, you
                    can:
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Log in to your account settings and update your user
                      account.
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Contact us using the contact information provided.
                    </span>
                  </li>
                </ul>

                <div>
                  <span>
                    Upon your request to terminate your account, we will
                    deactivate or delete your account and information from our
                    active databases. However, we may retain some information in
                    our files to prevent fraud, troubleshoot problems, assist
                    with any investigations, enforce our legal terms and/or
                    comply with applicable legal requirements.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>
                      <u>Cookies and similar technologies:</u>
                    </strong>{' '}
                    Most Web browsers are set to accept cookies by default. If
                    you prefer, you can usually choose to set your browser to
                    remove cookies and to reject cookies. If you choose to
                    remove cookies or reject cookies, this could affect certain
                    features or services of our Services.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    If you have questions or comments about your privacy rights,
                    you may email us at{' '}
                    <span>
                      <a target="_blank" href="mailto:info@usehacket.com">
                        info@usehacket.com
                      </a>
                    </span>
                    .
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div id="DNT">
                  <span>
                    <span>
                      <strong>
                        <h2>13. CONTROLS FOR DO-NOT-TRACK FEATURES</h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    Most web browsers and some mobile operating systems and
                    mobile applications include a Do-Not-Track ("DNT") feature
                    or setting you can activate to signal your privacy
                    preference not to have data about your online browsing
                    activities monitored and collected. At this stage, no
                    uniform technology standard for recognizing and implementing
                    DNT signals has been finalized. As such, we do not currently
                    respond to DNT browser signals or any other mechanism that
                    automatically communicates your choice not to be tracked
                    online. If a standard for online tracking is adopted that we
                    must follow in the future, we will inform you about that
                    practice in a revised version of this Privacy Notice.
                  </span>
                </div>

                <div>
                  <span>
                    <br />
                  </span>
                </div>

                <div>
                  <span>
                    California law requires us to let you know how we respond to
                    web browser DNT signals. Because there currently is not an
                    industry or legal standard for recognizing or honoring DNT
                    signals, we do not respond to them at this time.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div id="uslaws">
                  <span>
                    <span>
                      <strong>
                        <h2>
                          14. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY
                          RIGHTS?
                        </h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    If you are a resident of California, Colorado, Connecticut,
                    Delaware, Florida, Indiana, Iowa, Kentucky, Maryland,
                    Minnesota, Montana, Nebraska, New Hampshire, New Jersey,
                    Oregon, Rhode Island, Tennessee, Texas, Utah, or Virginia,
                    you may have the right to request access to and receive
                    details about the personal information we maintain about you
                    and how we have processed it, correct inaccuracies, get a
                    copy of, or delete your personal information. You may also
                    have the right to withdraw your consent to our processing of
                    your personal information. These rights may be limited in
                    some circumstances by applicable law. More information is
                    provided below.
                    <strong>
                      <h3>Categories of Personal Information We Collect</h3>
                    </strong>
                    The table below shows the categories of personal information
                    we have collected in the past twelve (12) months. The table
                    includes illustrative examples of each category and does not
                    reflect the personal information we collect from you. For a
                    comprehensive inventory of all personal information we
                    process, please refer to the section "
                  </span>
                  <a data-custom-class="link" href="#infocollect">
                    <span>
                      <span>WHAT INFORMATION DO WE COLLECT?</span>
                    </span>
                  </a>
                  <span>"</span>
                </div>

                <div>
                  <br />
                </div>

                <table className="min-w-full border border-gray-300">
                  <thead>
                    <tr>
                      <th className="border border-gray-300 p-2 text-left">
                        <span>
                          <strong>Category</strong>
                        </span>
                      </th>
                      <th className="border border-gray-300 p-2 text-left">
                        <span>
                          <strong>Examples</strong>
                        </span>
                      </th>
                      <th className="border border-gray-300 p-2 text-center">
                        <span>
                          <strong>Collected</strong>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>A. Identifiers</span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            Contact details, such as real name, alias, postal
                            address, telephone or mobile contact number, unique
                            personal identifier, online identifier, Internet
                            Protocol address, email address, and account name
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <div>
                          <br />
                        </div>
                        <div>
                          <span>YES</span>
                        </div>
                        <div>
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            B. Personal information as defined in the California
                            Customer Records statute
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            Name, contact information, education, employment,
                            employment history, and financial information
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <div>
                          <br />
                        </div>
                        <div data-custom-class="body_text">NO</div>
                        <div>
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            C. Protected classification characteristics under
                            state or federal law
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            Gender, age, date of birth, race and ethnicity,
                            national origin, marital status, and other
                            demographic data
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <div>
                          <br />
                        </div>
                        <div data-custom-class="body_text">NO</div>
                        <div>
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>D. Commercial information</span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            Transaction information, purchase history, financial
                            details, and payment information
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <div>
                          <br />
                        </div>
                        <div data-custom-class="body_text">NO</div>
                        <div>
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>E. Biometric information</span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>Fingerprints and voiceprints</span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <div>
                          <br />
                        </div>
                        <div data-custom-class="body_text">NO</div>
                        <div>
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            F. Internet or other similar network activity
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            Browsing history, search history, online behavior,
                            interest data, and interactions with our and other
                            websites, applications, systems, and advertisements
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <div>
                          <br />
                        </div>
                        <div data-custom-class="body_text">NO</div>
                        <div>
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>G. Geolocation data</span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>Device location</span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <div>
                          <br />
                        </div>
                        <div data-custom-class="body_text">NO</div>
                        <div>
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            H. Audio, electronic, sensory, or similar
                            information
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            Images and audio, video or call recordings created
                            in connection with our business activities
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <div>
                          <br />
                        </div>
                        <div data-custom-class="body_text">NO</div>
                        <div>
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            I. Professional or employment-related information
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            Business contact details in order to provide you our
                            Services at a business level or job title, work
                            history, and professional qualifications if you
                            apply for a job with us
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <div>
                          <br />
                        </div>
                        <div data-custom-class="body_text">NO</div>
                        <div>
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>J. Education Information</span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>Student records and directory information</span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <div>
                          <br />
                        </div>
                        <div data-custom-class="body_text">NO</div>
                        <div>
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            K. Inferences drawn from collected personal
                            information
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2">
                        <div>
                          <span>
                            Inferences drawn from any of the collected personal
                            information listed above to create a profile or
                            summary about, for example, an individual’s
                            preferences and characteristics
                          </span>
                        </div>
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <div>
                          <br />
                        </div>
                        <div data-custom-class="body_text">NO</div>
                        <div>
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-2">
                        <span>L. Sensitive personal Information</span>
                      </td>
                      <td className="border border-gray-300 p-2"></td>
                      <td className="border border-gray-300 p-2 text-center">
                        <div data-empty="true">
                          <br />
                        </div>
                        <div data-custom-class="body_text" data-empty="true">
                          NO
                        </div>
                        <div data-empty="true">
                          <br />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We may also collect other personal information outside of
                    these categories through instances where you interact with
                    us in person, online, or by phone or mail in the context of:
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Receiving help through our customer support channels;
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Participation in customer surveys or contests; and
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Facilitation in the delivery of our Services and to
                      respond to your inquiries.
                    </span>
                  </li>
                </ul>

                <div>
                  <span>
                    We will use and retain the collected personal information as
                    needed to provide the Services or for:
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Category A - As long as the user has an account with us
                    </span>
                  </li>
                </ul>

                <div>
                  <strong>
                    <span>
                      <h3>Sources of Personal Information</h3>
                    </span>
                  </strong>
                  <span>
                    Learn more about the sources of personal information we
                    collect in "
                  </span>
                  <a data-custom-class="link" href="#infocollect">
                    <span>WHAT INFORMATION DO WE COLLECT?</span>
                  </a>
                  <span>"</span>
                  <strong>
                    <span>
                      <h3>How We Use and Share Personal Information</h3>
                    </span>
                  </strong>
                  <span>
                    Learn more about how we use your personal information in the
                    section,
                  </span>
                  <a data-custom-class="link" href="#infouse">
                    <span>HOW DO WE PROCESS YOUR INFORMATION?</span>
                  </a>
                  <span>"</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    <strong>
                      Will your information be shared with anyone else?
                    </strong>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We may disclose your personal information with our service
                    providers pursuant to a written contract between us and each
                    service provider. Learn more about how we disclose personal
                    information to in the section, "
                  </span>
                  <a data-custom-class="link" href="#whoshare">
                    <span>
                      WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
                    </span>
                  </a>
                  <span>"</span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We may use your personal information for our own business
                    purposes, such as for undertaking internal research for
                    technological development and demonstration. This is not
                    considered to be "selling" of your personal information.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We have not sold or shared any personal information to third
                    parties for a business or commercial purpose in the
                    preceding twelve (12) months.&nbsp;
                  </span>
                  <span>
                    We have disclosed the following categories of personal
                    information to third parties for a business or commercial
                    purpose in the preceding twelve (12) months:
                  </span>
                </div>

                <div>
                  <span>
                    The categories of third parties to whom we disclosed
                    personal information for a business or commercial purpose
                    can be found under "
                  </span>
                  <a data-custom-class="link" href="#whoshare">
                    <span>
                      <span>
                        WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL
                        INFORMATION?
                      </span>
                    </span>
                  </a>
                  <span>"</span>
                </div>

                <div>
                  <span>
                    <strong>Your Rights</strong>
                  </span>
                  <span>
                    <span>
                      <span>
                        You have rights under certain US state data protection
                        laws. However, these rights are not absolute, and in
                        certain cases, we may decline your request as permitted
                        by law. These rights include:
                      </span>
                    </span>
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Right to know</strong> whether or not we are
                      processing your personal data
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Right to access&nbsp;</strong>your personal data
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Right to correct&nbsp;</strong>inaccuracies in
                      your personal data
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Right to request</strong> the deletion of your
                      personal data
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Right to obtain a copy&nbsp;</strong>of the
                      personal data you previously shared with us
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Right to non-discrimination</strong> for
                      exercising your rights
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      <strong>Right to opt out</strong> of the processing of
                      your personal data if it is used for targeted advertising
                      (or sharing as defined under California’s privacy law),
                      the sale of personal data, or profiling in furtherance of
                      decisions that produce legal or similarly significant
                      effects ("profiling")
                    </span>
                  </li>
                </ul>

                <div>
                  <span>
                    <span>
                      Depending upon the state where you live, you may also have
                      the following rights:
                    </span>
                  </span>
                </div>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Right to access the categories of personal data being
                      processed (as permitted by applicable law, including the
                      privacy law in Minnesota)
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Right to obtain a list of the categories of third parties
                      to which we have disclosed personal data (as permitted by
                      applicable law, including the privacy law in California,
                      Delaware, and Maryland)
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Right to obtain a list of specific third parties to which
                      we have disclosed personal data (as permitted by
                      applicable law, including the privacy law in Minnesota and
                      Oregon)
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Right to review, understand, question, and correct how
                      personal data has been profiled (as permitted by
                      applicable law, including the privacy law in Minnesota)
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Right to limit use and disclosure of sensitive personal
                      data (as permitted by applicable law, including the
                      privacy law in California)
                    </span>
                  </li>
                </ul>

                <ul className="list-disc list-inside ml-4 mb-4">
                  <li>
                    <span>
                      Right to opt out of the collection of sensitive data and
                      personal data collected through the operation of a voice
                      or facial recognition feature (as permitted by applicable
                      law, including the privacy law in Florida)
                    </span>
                  </li>
                </ul>

                <strong>
                  <span>
                    <h3>How to Exercise Your Rights</h3>
                  </span>
                </strong>
                <span>
                  <span>
                    <span>
                      To exercise these rights, you can contact us by visiting{' '}
                      <span>
                        <a target="_blank" href="https://usebrandcheck.com">
                          https://usebrandcheck.com
                        </a>
                      </span>
                      , by emailing us at{' '}
                      <span>
                        <a
                          target="_blank"
                          href="mailto:privacy@influenceranalysis.ai"
                        >
                          privacy@influenceranalysis.ai
                        </a>
                      </span>
                      , by visiting{' '}
                      <span>
                        <a
                          target="_blank"
                          href="https://influenceranalysis.ai/contact"
                        >
                          https://influenceranalysis.ai/contact
                        </a>
                      </span>
                      , or by referring to the contact details at the bottom of
                      this document.
                    </span>
                  </span>
                </span>
                <div>
                  <br />
                </div>

                <div>
                  <span>
                    Under certain US state data protection laws, you can
                    designate an authorized agent to make a request on your
                    behalf. We may deny a request from an authorized agent that
                    does not submit proof that they have been validly authorized
                    to act on your behalf in accordance with applicable laws.
                  </span>
                </div>

                <strong>
                  <span>
                    <h3>Request Verification</h3>
                  </span>
                </strong>
                <span>
                  Upon receiving your request, we will need to verify your
                  identity to determine you are the same person about whom we
                  have the information in our system. We will only use personal
                  information provided in your request to verify your identity
                  or authority to make the request. However, if we cannot verify
                  your identity from the information already maintained by us,
                  we may request that you provide additional information for the
                  purposes of verifying your identity and for security or
                  fraud-prevention purposes.
                </span>
                <div>
                  <br />
                </div>

                <div>
                  <span>
                    If you submit the request through an authorized agent, we
                    may need to collect additional information to verify your
                    identity before processing your request and the agent will
                    need to provide a written and signed permission from you to
                    submit such request on your behalf.
                  </span>
                </div>

                <strong>
                  <span>
                    <h3>Appeals</h3>
                  </span>
                </strong>
                <span>
                  Under certain US state data protection laws, if we decline to
                  take action regarding your request, you may appeal our
                  decision by emailing us at{' '}
                  <span>
                    <a target="_blank" href="mailto:info@usehacket.com">
                      info@usehacket.com
                    </a>
                  </span>
                  . We will inform you in writing of any action taken or not
                  taken in response to the appeal, including a written
                  explanation of the reasons for the decisions. If your appeal
                  is denied, you may submit a complaint to your state attorney
                  general.
                </span>
                <strong>
                  <span>
                    <h3>California "Shine The Light" Law</h3>
                  </span>
                </strong>
                <span>
                  California Civil Code Section 1798.83, also known as the
                  "Shine The Light" law, permits our users who are California
                  residents to request and obtain from us, once a year and free
                  of charge, information about categories of personal
                  information (if any) we disclosed to third parties for direct
                  marketing purposes and the names and addresses of all third
                  parties with which we shared personal information in the
                  immediately preceding calendar year. If you are a California
                  resident and would like to make such a request, please submit
                  your request in writing to us by using the contact details
                  provided in the section "
                </span>
                <a data-custom-class="link" href="#contact">
                  <span>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
                </a>
                <span>"</span>
                <div>
                  <br />
                </div>

                <div id="policyupdates">
                  <span>
                    <span>
                      <strong>
                        <h2>15. DO WE MAKE UPDATES TO THIS NOTICE?</h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    <em>
                      <strong>In Short:&nbsp;</strong>Yes, we will update this
                      notice as necessary to stay compliant with relevant laws.
                    </em>
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>
                    We may update this Privacy Notice from time to time. The
                    updated version will be indicated by an updated "Revised"
                    date at the top of this Privacy Notice. If we make material
                    changes to this Privacy Notice, we may notify you either by
                    prominently posting a notice of such changes or by directly
                    sending you a notification. We encourage you to review this
                    Privacy Notice frequently to be informed of how we are
                    protecting your information.
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div id="contact">
                  <span>
                    <span>
                      <strong>
                        <h2>16. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    If you have questions or comments about this notice, you may
                    email us at{' '}
                    <span>
                      <a target="_blank" href="mailto:info@usehacket.com">
                        info@usehacket.com
                      </a>
                    </span>{' '}
                    or&nbsp;contact us by post at:
                  </span>
                </div>

                <div>
                  <br />
                </div>

                <div>
                  <span>Hacket Services OÜ</span>
                </div>

                <div>
                  <span>Sepapaja tn 6, Lasnamäe linnaosa</span>
                </div>

                <div>
                  <span>Tallinn, Harju maakond 15551</span>
                </div>

                <div>
                  <span>Estonia</span>
                </div>

                <div>
                  <br />
                </div>

                <div id="request">
                  <span>
                    <span>
                      <strong>
                        <h2>
                          17. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE
                          COLLECT FROM YOU?
                        </h2>
                      </strong>
                    </span>
                  </span>
                  <span>
                    Based on the applicable laws of your country or state of
                    residence in the US, you may have the right to request
                    access to the personal information we collect from you,
                    details about how we have processed it, correct
                    inaccuracies, or delete your personal information. You may
                    also have the right to withdraw your consent to our
                    processing of your personal information. These rights may be
                    limited in some circumstances by applicable law. To request
                    to review, update, or delete your personal information,
                    please visit:{' '}
                    <span>
                      <a target="_blank" href="https://usebrandcheck.com">
                        https://usebrandcheck.com
                      </a>
                    </span>
                    .
                  </span>
                </div>
              </div>
            </main>
          </div>
        </div>
      </main>
    </div>
  );
}
